export default "__VITE_PUBLIC_ASSET__1d00aee0__"